import { graphqlApolloClient } from "../graphql-apollo-client"
import { submission } from "../../graphql"
import {
  GET_ACTIVITY_ASSISTANTS_AND_ASSISTANCE_AND_COUNT,
  GET_ASSISTANTS_REPORT_URL,
  GET_PROJECT_ASSISTANTS_AND_COUNT,
  GET_OBJETIVES
} from "./graphql"
import { GET_ASSISTANTS_COUNT_BY_AGE_AND_GENDER } from "./graphql/get-assistants-count-by-age-range-and-gender"
import { GET_ACTIVITY_ASSISTANTS_BY_AGE_RANGE } from "./graphql/get-activity-assistants-by-age-range"

export const AssistantsServices = () => {
  const getProjectAssistantsBySubmission = async ({ id }) => {
    const { data } = await graphqlApolloClient.query({
      query: submission.queries.getProjectAssistants,
      fetchPolicy: "network-only",
      variables: {
        id
      }
    })

    return data?.ProjectAssistants
  }

  const getProjectAssistantsAndCountBySubmission = async ({
    id,
    first,
    skip,
    filter,
    filterBy,
    sortingBy,
    sortingOrder
  }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_PROJECT_ASSISTANTS_AND_COUNT,
      fetchPolicy: "network-only",
      variables: {
        id,
        skip,
        first,
        filter,
        filterBy,
        sortingBy: sortingBy || undefined,
        sortingOrder: sortingOrder || undefined
      }
    })

    return data
  }

  const getActivityAssistantsAndAssistanceAndCount = async ({ activityId, first, skip, filter }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_ACTIVITY_ASSISTANTS_AND_ASSISTANCE_AND_COUNT,
      fetchPolicy: "network-only",
      variables: {
        skip,
        first,
        filter,
        activityId
      }
    })

    return data
  }

  const getObjetives = async ({ submissionId }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_OBJETIVES,
      fetchPolicy: "network-only",
      variables: {
        id: submissionId
      }
    })

    return data?.AsistantsObjectivesQuery
  }

  const getAssistantsReportUrl = async ({ submissionId, filter }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_ASSISTANTS_REPORT_URL,
      fetchPolicy: "network-only",
      variables: {
        filter,
        id: submissionId
      }
    })

    return data?.generateAssistantsReportBySubmission
  }

  const getAssistantsCountByAgeRange = async ({ submissionId }) => {
    const result = await graphqlApolloClient.query({
      query: GET_ASSISTANTS_COUNT_BY_AGE_AND_GENDER,
      fetchPolicy: "network-only",
      variables: { submissionId }
    })
    return result?.data?.submissionAssistantsAgeRangeCounts
  }

  const getActivityAssistantsByAgeRange = async ({ submissionId, lowerRange, highestRange }) => {
    const result = await graphqlApolloClient.query({
      query: GET_ACTIVITY_ASSISTANTS_BY_AGE_RANGE,
      fetchPolicy: "network-only",
      variables: { submissionId, lowerRange, highestRange }
    })
    return result?.data?.projectAssistantsByAgeRange
  }

  return {
    getAssistantsReportUrl,
    getAssistantsCountByAgeRange,
    getActivityAssistantsByAgeRange,
    getProjectAssistantsBySubmission,
    getActivityAssistantsAndAssistanceAndCount,
    getProjectAssistantsAndCountBySubmission,
    getObjetives
  }
}
